/**
 * The only place allowed to read the machine clock (lint rule iris/no-business-new-date).
 * Business code receives a Clock; tests inject a fixed or controllable one.
 */
export interface Clock {
  /** Current instant in epoch milliseconds. */
  now(): number;
}

export const systemClock: Clock = { now: () => Date.now() };

/** Another clock running `offsetMs` ahead (development only: DEV_CLOCK_OFFSET, M20 manual tests). */
export function offsetClock(base: Clock, offsetMs: number): Clock {
  return { now: () => base.now() + offsetMs };
}

export function fixedClock(epochMillis: number): Clock {
  return { now: () => epochMillis };
}

/** A clock tests can move forward. */
export function manualClock(
  startEpochMillis: number,
): Clock & { advance(ms: number): void; set(ms: number): void } {
  let current = startEpochMillis;
  return {
    now: () => current,
    advance: (ms) => {
      current += ms;
    },
    set: (ms) => {
      current = ms;
    },
  };
}
